import { handleRequest } from "../utilities/requestHandler";

export const getProductsById = (products, siteNumber) =>
    handleRequest("post", "/products/byids", {
        products: products,
        site_number: siteNumber,
    });

export const getOptions = () =>
    handleRequest("get", "/options");

export const getCartRecommendations = (productIds, siteNumber) =>
    handleRequest("post", "/orders/getCartRecommendations", {
        products: productIds,
        site_number: siteNumber,
    });

export const getUserCart = (userId) =>
    handleRequest("post", "/cart/getCart", { userId });

export const updateUserCart = (userId, cart) =>
    handleRequest("post", "/cart", { userId, cart });

export const getCartCTP = (requestBody) =>
    handleRequest("post", "/erp/getCartCTP", requestBody);

export const addModelCartItems = (payload) =>
    handleRequest("post", "/cart/model_add_to_cart", payload);
